module.exports = __webpack_public_path__ + "img/upper_pockets_move_vertically.f05a99a9.png";